// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- RxJs
import { BehaviorSubject, Observable, of } from 'rxjs';

// --- HS Code
import {
  ApplicationError,
  JournalCategoryModel,
  JournalQuadrantModel,
} from '../../../models';
import { AppService } from '../app.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export abstract class QuadrantsBaseService {
  protected _quadrants$: BehaviorSubject<JournalQuadrantModel[] | null>;
  get quadrants$(): Observable<JournalQuadrantModel[] | null> {
    return this._quadrants$;
  }

  protected _styles$ = new BehaviorSubject<JournalCategoryModel[]>([]);
  get styles$(): Observable<JournalCategoryModel[]> {
    return this._styles$;
  }

  protected _currentId$: BehaviorSubject<number | null>;
  get currentId$(): Observable<number | null> {
    return this._currentId$;
  }

  constructor(
    protected appService: AppService,
    protected translateService: TranslateService
  ) {
    this._quadrants$ = new BehaviorSubject<JournalQuadrantModel[] | null>(null);
    this._currentId$ = new BehaviorSubject<number | null>(null);
  }

  abstract load(override?: boolean): void;

  setCurrent(quadrantId: number) {
    this._currentId$.next(quadrantId);
  }

  protected _createError(err: any) {
    const error = {
      errorMessage: this.translateService.instant("errorMessageGenericBackend"),
    } as ApplicationError;
    this.appService.setLastError(error);
    return of(null);
  }
}
